import { AxiosError, AxiosResponse } from "axios";
// import { IFixedAndMetaField } from 'common/FlexFieldsUtils';
import http from "../common/http-commons";
// import { IVendorListPayload, IVendorRequest, IVendorResponse } from 'models/vendor';
// import { CLIENT_SETUP_FORM, CLIENT_SETUP_FORM_FOR_ADMIN_USER } from 'screensLayoutData/client';

// import { IAPIKeysRequest, IAPIKeysResponse } from '../models';
import { IGetListRequest, IResponse, IServerError } from "../models/common";
// import { IDesignationListPayload, IDesignationRequest, IDesignationResponse } from '../models/designation';
import { GridSize } from "@mui/material";
import { DataType, FieldType } from "@websential/cosmic-v20";
import {
	IDesignation,
	IDesignationListPayload,
	IDesignationResponse,
} from "../models/Designation";
// import { INITIAL_PAGE_SIZE } from 'common/constants';

export const DesignationService = {
	getDesignation: async (
		clientId: string,
		data: IGetListRequest,
		navigateToLogout: (path: string) => void
	): Promise<
		IDesignationListPayload | IServerError | IResponse | IDesignationResponse[]
	> => {
		try {
			const response: AxiosResponse<IDesignationListPayload> =
				await http.get<IDesignationListPayload>(
					"/v1/designations/?client_id=" +
						clientId +
						"&order_by=" +
						data.order_by +
						"&order_direction=" +
						data.order_direction +
						"&page=" +
						data.page +
						"&size=" +
						data.size +
						"&search_query=" +
						data.search_query
				);

			if (response.status === 200) {
				return response.data;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}
			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
	getById: async (
		id: string | undefined,
		navigateToLogout: (path: string) => void
	): Promise<IDesignation | IServerError | IResponse | null | any> => {
		if (!id) return null;
		try {
			const response: AxiosResponse<IDesignation> =
				await http.get<IDesignation>(`/v1/designations/${id}/`);

			if (response.status === 200) {
				return response.data;
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
	create: async (
		requestPayload: any
	): Promise<IDesignation | IServerError | IResponse | any> => {
		if (requestPayload.id) {
			
			try {
				const response: AxiosResponse<IDesignation> =
					await http.put<IDesignation>(
						`/v1/designations/${requestPayload.id}/?client_id=${requestPayload.clientId}`,
						requestPayload
					);

				if (response.status === 200) {
					return response;
				} else if (response.status === 400) {
					return response.data;
				} else if (response.status === 500) {
					return {
						status: false,
						message: "Something went wrong.",
						error: true,
					};
				}
			} catch (error) {
				const axiosError = error as AxiosError;
				console.error("An error occurred:", axiosError);
				const errorMessage =
					axiosError.response && typeof axiosError.response.data === "string"
						? axiosError.response.data
						: "Unknown error";
				if (axiosError && axiosError.status === 401) {
					requestPayload.navigateToLogout("/logout");
					return {
						status: false,
						message: "UnAuthrized",
					};
				} else {
					
					return {
						status: false,
						message: errorMessage,
					};
				}
			}
		}

	
		try {
			const response: AxiosResponse<IDesignation> =
				await http.post<IDesignation>(
					`/v1/designations/?client_id=${requestPayload.clientId}`,
					requestPayload
				);

		
			if (response.status === 201) {
				return response;
			} else if (response.status === 400) {
				return response.data;
			} else if (response.status === 401) {
				// window.location.href = '/logout';
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				requestPayload.navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
	delDesignation: async (
		delPayload: any
	): Promise<string | IServerError | IResponse | any> => {
		
		// return new Promise(resolve => setTimeout(() => resolve("Flex Field has been deleted successfully"), 1000));
		try {
			const response: AxiosResponse<string> = await http.delete<string>(
				`/v1/designations/${delPayload.designationId}/`
			);

			if (response.status === 204) {
				return "Designation has been deleted successfully";
			} else if (response.status === 200) {
				return "Designation has been deleted successfully";
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				delPayload.navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
	delBulkDesignationes: async (
		requestPayload: any
	): Promise<string | IServerError | IResponse> => {
		
		try {
			const response = await http.delete<string>(`/v1/designations/`, {
				data: requestPayload.designationIds,
			});
			if (response.status === 200) {
				return response.data;
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}
		
			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				requestPayload.navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
	getGetDesignationDDL: async (
		clientId: string
	): Promise<any | IServerError | IResponse | null> => {
		const response: AxiosResponse<any[]> = await http.get<any[]>(
			`/v1/designations/designation-ddl?client_id=${clientId}`
		);

	

		if (response.status === 200) {
			return response.data;
		}

		return {
			status: false,
			message: "Something went wrong please try again later.",
		};
	},
	archiveDesignation: async (
		archivePayload: any
	): Promise<string | IServerError | IResponse | any> => {

		// return new Promise(resolve => setTimeout(() => resolve("Flex Field has been deleted successfully"), 1000));
		try {
			const response: AxiosResponse<string> = await http.post<string>(
				`/v1/designation/${archivePayload.designationId}/`
			);

			if (response.status === 201) {
				return "Designation has been archived successfully";
			} else if (response.status === 200) {
				return "Designation has been archived successfully";
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				archivePayload.navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
};
